/**
 * Prefetch storefront URLs on hover / focus / touchstart to shorten SSR nav latency.
 * Complements Speculation Rules where supported.
 */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const prefetched = new Set();
  const MAX_PREFETCH = 24;

  const isPrefetchable = (url) => {
    if (!url || url.origin !== window.location.origin) return false;
    if (url.hash && url.pathname === window.location.pathname) return false;
    if (url.pathname === window.location.pathname && url.search === window.location.search) {
      return false;
    }
    // Skip cart/checkout/account and non-HTML assets
    if (/^\/(cart|checkouts?|account|apps)\b/i.test(url.pathname)) return false;
    if (/\.(js|css|png|jpe?g|webp|gif|svg|mp3|mp4|woff2?)(\?|$)/i.test(url.pathname)) return false;
    return true;
  };

  const prefetch = (href) => {
    if (!href || prefetched.size >= MAX_PREFETCH) return;

    let url;
    try {
      url = new URL(href, window.location.href);
    } catch {
      return;
    }

    if (!isPrefetchable(url) || prefetched.has(url.href)) return;
    prefetched.add(url.href);

    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = url.href;
    document.head.appendChild(link);
  };

  const getAnchor = (target) => {
    if (!(target instanceof Element)) return null;
    return target.closest('a[href]');
  };

  const onIntent = (event) => {
    const anchor = getAnchor(event.target);
    if (!anchor || anchor.hasAttribute('download') || anchor.target === '_blank') return;
    prefetch(anchor.href);
  };

  document.addEventListener('pointerover', onIntent, { passive: true });
  document.addEventListener('focusin', onIntent, { passive: true });
  document.addEventListener('touchstart', onIntent, { passive: true, capture: true });
})();
